import ClipboardIcon from "../images/ClipboardIcon.mjs";

/**
 * App icon for Log
 * @see {GlyphIcon}
 * @see {ClipboardIcon}
 */
const AppLogIcon = class extends ClipboardIcon {}

export default AppLogIcon;